import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Title } from "../../components/NewTitle";

export const CustomerDetailIdea = (props) => {
  const { t } = useTranslation();
  const { ideas, scale, theme } = props;
  return (
    <section>
      <div className="customer-detail-idea">
        <div className="inner">
          <div className="content">
            <Title
              title={t("customer.heigh-educate.ideas.title")}
              align="left"
            ></Title>
            <div className="customer-idea-responsive">
              {ideas.map((idea) => {
                return (
                  <div className="card">
                    <div className="card-content">
                      <div className="text-warp">
                        <span
                          className="dot"
                          style={{ background: theme }}
                        ></span>
                        <span className="text">{idea.descript}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
